import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';

class PriceComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      pageContent: '',
      srcpValue: '',
      promocode: '',
      promocodeMessageKey: '', // New state to hold the message key for localization
      isError: false, // New state to determine if the message is an error
    };
  }

  getBrowserLanguage() {
    const language = this.props.intl.locale.split(/[-_]/)[0];
    return language ? language : 'en';
  }

  componentDidMount() {
    this.props.eventToGAnalitycs("price_show");
    this.fetchPricePage();
    this.checkSrcpValue();
  }

  checkSrcpValue = () => {
    const srcpValue = localStorage.getItem('srcp');
    this.setState({ srcpValue });
  }

  handleFieldEdit(name, e) {
    this.setState({[name]: e.target.value || ''});
  }

  fetchPricePage = async () => {
    let htmlfile = '/prices-section-en.html?v=9';
    let agrfile = 'useragreement-en.html';
    if (this.getBrowserLanguage() === "ru") {
      htmlfile = '/prices-section.html?v=13';
      agrfile = 'useragreement-ru.html';
    }
    const response = await fetch(htmlfile);
    const html = await response.text();
    this.setState({ pageContent: html });
    this.setState({ useragreement: agrfile });
  }

  handleSendPromocode = async () => {
    const { promocode } = this.state;
    
    this.props.eventToGAnalitycs('use_promocode');
    const topic = this.props.tinode.getMeTopic();  
    const query = topic.startMetaQuery().withDesc().build();

    query.desc.inchatgpt = promocode;
    query.desc.inchatgpttype = "use_promocode";
    
    try {
      const result = await topic.getMeta(query);

      if (result.desc.outchatgpt === 'error') {
        // Error case: Invalid or previously used promocode
        this.setState({
          promocodeMessageKey: 'promocode_error',
          isError: true,
        });
      } else {
        // Success case: Promocode applied successfully
        this.setState({
          promocodeMessageKey: 'promocode_success',
          isError: false,
        });
      }

    } catch (error) {
      console.error('Error applying promocode:', error);
      // You can add further error handling here if necessary
    }
  };

  renderPromocodeMessage() {
    const { promocodeMessageKey, isError } = this.state;

    // Conditionally render the message based on the key
    if (!promocodeMessageKey) return null;

    if (this.state.isError) {
      return (
        <div className='error-message' >
          <FormattedMessage id='promocode_error' />
        </div>
      );
    } else {
      return (
        <div className='success-message'>
          <FormattedMessage id='promocode_success' />
        </div>
      );
    }
  }

  render() {
    const { pageContent, srcpValue } = this.state;

    return (
      <>
        <div className='price-overlay'>
          <div className='price-container'>
            <div className="cancel">
              <a href="#" onClick={e => { e.preventDefault(); this.props.onCancel(); }}>
                <i className="material-icons gray">close</i>
              </a>
            </div>
            <div>
              <h2>
                <FormattedMessage id="choosetarif" defaultMessage="Choose payment option" description="Choose payment option" />
              </h2>
            </div>
            <div dangerouslySetInnerHTML={{ __html: pageContent }} />
            <div>
              
             <div className='margin-left-small'>
                <label className="small margin-top-big" htmlFor="promocode">
                  <FormattedMessage id="input_promocode" defaultMessage="If you have a promo code, enter it" />
                </label>
                <div className="promocode-block">
                  <div className='promocode-text'>
                    <FormattedMessage id="promocode" defaultMessage="promocode">
                      {(placeholder) => (
                        <input type="text" id="promocode" placeholder={placeholder}
                          value={this.state.promocode} 
                          onChange={this.handleFieldEdit.bind(this, 'promocode')}
                          required 
                          tabIndex={0} 
                        />
                      )}
                    </FormattedMessage>
                  </div>
                  <button className='secondary' onClick={this.handleSendPromocode}>
                    <FormattedMessage id="button_promocode" defaultMessage="Apply" />
                  </button>
                </div>

                {/* Display promocode message */}
                {this.renderPromocodeMessage()}
              </div> 
            </div>
          </div>
        </div>
        {srcpValue != 'yah1' && (
          <style>{`
            #p100 { display: none; }

          `}</style> 
        )}

        {srcpValue === 'yah' && (
          <style>{`
            #p100 { display: none; }
            #p300 { display: none; }
            #p500 { display: none; }
            #p800 { display: none; }
          `}</style>
        )}

        {srcpValue === 'yah5' && (
          <style>{`
            #p100 { display: none; }
            #p300 { display: none; }
          `}</style>
        )}

        {srcpValue === 'yah8' && (
          <style>{`
            #p100 { display: none; }
            #p300 { display: none; }
            #p500 { display: none; }
          `}</style>
        )}

        {srcpValue === 'yah15' && (
          <style>{`
            #p100 { display: none; }
            #p300 { display: none; }
            #p500 { display: none; }
            #p800 { display: none; }
            #p1000 { display: none; }
          `}</style>
        )}


        

        
      </>
    );
  }
}

export default injectIntl(PriceComponent);
